<script setup lang="ts">
import { LineupModel } from '@collector/desktop-feature-lineups'
import { runLoader, useConfirmModal } from '@collector/shared-ui'
import { Participant, SubParticipant } from '@collector/sportsapi-types'
import { useEvent } from '@desktop/views/Relation/composables'
import BaseLineupsModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/BaseLineupsModal/BaseLineupsModal.vue'
import InvalidAssignedPlayersConfirmModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/ConfirmModals/InvalidAssignedPlayersConfirmModal.vue'
import NoCaptainConfirmModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/ConfirmModals/NoCaptainConfirmModal.vue'
import {
  UpdateLineupsFn,
  useLineupConfig,
} from '@desktop/views/Relation/Sports/composables'

import NoCoachConfirmModal from '../../../components/RelationView/Main/MainSummary/Lineups/ConfirmModals/NoCoachConfirmModal.vue'

interface Props {
  participant: Participant
}
const props = defineProps<Props>()

// composables
const { openModalForConfirm } = useConfirmModal()
const { config } = useLineupConfig()
const { event } = useEvent()

// methods
async function confirmUpdateLineup(
  lineup: LineupModel,
  _initialLineup: LineupModel,
  updateLineups: UpdateLineupsFn,
  captain?: SubParticipant | null,
): Promise<void> {
  const coachCount = lineup.coach.length

  const firstLineupCount = lineup.firstLineup.length
  const firstLineupMax = config.value.positions.firstLineup.maxCount ?? Infinity

  if (!captain) await openModalForConfirm(NoCaptainConfirmModal)
  if (coachCount === 0) await openModalForConfirm(NoCoachConfirmModal)
  if (firstLineupCount > 0 && firstLineupCount !== firstLineupMax)
    await openModalForConfirm<typeof InvalidAssignedPlayersConfirmModal>(
      InvalidAssignedPlayersConfirmModal,
      {
        maxPlayersInFirstLineup: firstLineupMax,
      },
    )

  await runLoader(updateLineups(event.value.id, props.participant.id, lineup))
}
</script>

<template>
  <BaseLineupsModal
    :participant
    :confirmUpdateLineup
  />
</template>
